import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

function NotFoundPage() {
  const { palette } = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Stack spacing={3}>
            <Stack
              direction="row"
              sx={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
              <Typography variant="h4" color="primary.main">
                {t('pages.404.title')}
              </Typography>
              <FontAwesomeIcon
                icon="fa-triangle-exclamation"
                size="2x"
                color={palette.primary.main}
              />
            </Stack>
            <Typography>{t('pages.404.message')}</Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/')}
              sx={{ alignSelf: 'center' }}
            >
              {t('pages.404.button')}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}

export default NotFoundPage;
